var map = {
	"./16-0-8.pdf": 3969,
	"./ADAMSEARTH.pdf": 1239,
	"./BLACKSTRAP.pdf": 3658,
	"./BlackStone24.pdf": 1949,
	"./HUMIC-19.pdf": 2354,
	"./OMEGAX34.pdf": 3749,
	"./impulse.pdf": 9680,
	"./kelplant.pdf": 5108,
	"./sugarCal.pdf": 2493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6863;